/**
 * ViewMoreButton Component
 * Displays a "View More" button for paginated content
 */

import React from 'react';
import { Box, Link as DSLink } from '@saviynt/design-system';

interface ViewMoreButtonProps {
  remainingCount: number;
  onClick: () => void;
  className?: string;
}

/**
 * ViewMoreButton Component
 * Displays a "View More" button for paginated content
 * @param remainingCount - Number of remaining items to show
 * @param onClick - Callback function when button is clicked
 * @param className - Optional CSS class name
 * @returns JSX element or null if no remaining items
 */
function ViewMoreButton({
  remainingCount,
  onClick,
  className = '',
}: ViewMoreButtonProps) {
  if (remainingCount <= 0) {
    return null;
  }

  return (
    <Box className={`Sod-TCodeListRow-view-more-container ${className || ''}`}>
      <Box className='Sod-TCodeListRow-view-more-link'>
        <DSLink
          text={`View ${remainingCount} more insights`}
          kind='button'
          onClick={onClick}
          suffixIconKind='ChevronDown'
        />
      </Box>
    </Box>
  );
}

ViewMoreButton.defaultProps = {
  className: '',
};

export default ViewMoreButton;
